import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-kopfdaten-aktualisieren';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungKopfdatenAktualisierenEffects {

    VeranstaltungKopfdatenAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_KOPFDATEN_AKTUALISIEREN),
        mergeMap((x: ac.PostVeranstaltungKopfdatenAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungKopfdatenAktualisieren(x.veranstaltungKopfdatenAktualisierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungKopfdatenAktualisierenErfolgreichAction(result, x.veranstaltungKopfdatenAktualisierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungKopfdatenAktualisierenFehlerAction(error, x.veranstaltungKopfdatenAktualisierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
